import { finalRecommendations, recommendedBy } from "../../Constants";

export const getRecommendedByName = (recommendedByValue) => {
  switch (recommendedByValue) {
    case recommendedBy.Advisor:
      return "Advisor";
    case recommendedBy.GIFsInformationSpecialists:
      return "GIFs Information Specialists";
    case recommendedBy.Referee:
      return "Referee";
    case recommendedBy.ApplicantSuggestedReviewer:
      return "Applicant";
    case recommendedBy.Other:
      return "Other";
    default:
      return "";
  }
};

export const getFinalRecommendationsLabel = (recommendationValue) => {
  let recommendation = finalRecommendations.filter(
    (fr) => fr.value === recommendationValue
  )[0];
  if (!recommendation) return "";
  return recommendation.label;
};

export const showDate = (shortDateString) => {
  if (shortDateString === "0001-01-01T00:00:00") return "---";
  shortDateString = shortDateString.slice(0, shortDateString.indexOf("T"));
  let date = new Date(shortDateString);
  let dateDisplay = date.toLocaleDateString("en-GB");
  return dateDisplay;
};
